// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cbphb","colBig":"styles_colBig__3j_uM","colSmall":"styles_colSmall__leFb1","shopifyNameWrapper":"styles_shopifyNameWrapper__1DqjM"};